import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Use a more efficient way to get the root element
const rootElement = document.getElementById('root');

// Only create root if element exists
if (rootElement) {
  // Add main content ID for skip link
  rootElement.setAttribute('id', 'main-content');
  
  const root = createRoot(rootElement);
  
  // Render the app
  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  );
} else {
  console.error('Root element not found');
}

// Preload critical images after initial render
const preloadCriticalImages = () => {
  const criticalImages = [
    'https://images.pexels.com/photos/3184360/pexels-photo-3184360.jpeg?auto=compress&cs=tinysrgb&w=800&h=600&fit=crop',
    'https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg?auto=compress&cs=tinysrgb&w=800&h=600&fit=crop',
    'https://images.pexels.com/photos/3757942/pexels-photo-3757942.jpeg?auto=compress&cs=tinysrgb&w=800&h=600&fit=crop'
  ];
  
  criticalImages.forEach(src => {
    const img = new Image();
    img.src = src;
  });
};

// Execute after initial render
window.addEventListener('DOMContentLoaded', () => {
  setTimeout(preloadCriticalImages, 100);
});